import { Map } from 'immutable'
import React from 'react'
import { useSelector } from 'react-redux'
import { usePageElementPosition } from '../../../../hooks/useWidgetComponent'
import { StyleElement } from '../../../Main/StyleElement'

const ElementPosition = ({ uid, PageID, isPreview }) => {
  const { position, vis, extra, extraKey, size } = usePageElementPosition(uid, PageID, isPreview)
  let style = ''
  if (String(position).trim()) {
    style += `.ft--pos--${uid}{${String(position).trim()}}`
  }
  if (String(vis).trim()) {
    style += `.ft--vis--${uid}{${String(vis).trim()}}`
  }
  if (extraKey && extra) {
    style += `.ft--pos--${uid} ${extraKey}{${String(extra).trim()}}`
  }
  if (size) {
    style += size
  }
  return `${style} .ft--component-wrap.ft--pos--${uid}, .ft--component-wrap.ft--${uid}--root { opacity: unset; }`.replace(
    /\r|\n|[\s]{2,}/g,
    ''
  )
}

const ElementsPosition = ({ isPreview, customPageID }) => {
  const PageID = useSelector((state) => customPageID || state.get('page'))
  const elements = useSelector((state) => state.getIn(['pages', PageID, 'Props', 'elements'], Map()))
  return elements
    .map((_, uid, i) => {
      return <ElementPosition key={uid} uid={uid} PageID={PageID} isPreview={isPreview} />
    })
    .toList()
}

export function PageElementsPositions({ isPreview, customPageID }) {
  return (
    <StyleElement
      key={`ft-position${customPageID || ''}`}
      uid={`ft-position${customPageID || ''}`}
      styleEl={<ElementsPosition isPreview={isPreview} customPageID={customPageID} />}
    />
  )
}
